import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
} from '../../components/Form';


import {
    Title,
    PanelBox,
    Paragraph,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffShopServiceTokensDelete(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handleCancel = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handleDelete = async () => {
        await postData('/api/panel/page/taroff-shop-service-tokens-delete/save-data', {
            id: allProps['taroff-shop-service-tokens-id'],
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    useEffect(() => {
        postData('/api/panel/page/taroff-shop-service-tokens-delete/form-data', {
            id: allProps['taroff-shop-service-tokens-id'],
        }).then((response) => {});
    }, []);
    return (
        <PanelBox>
            <DataForm>
                <Title>هشدار</Title>
                <Paragraph>رکورد حذف شود؟</Paragraph>
                <LeftComponents>
                                    <Button onClick={handleCancel}>انصراف</Button>
                <Button onClick={handleDelete}>حذف</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
